import React from "react";


import { CardMedia } from "@material-ui/core";
import CustomImagePreview from "../CustomImagePreview/CustomImagePreview";


interface CustomCarouselProps {
    ImageUrls: string | string[]
}

export default function CustomCarousel(props: CustomCarouselProps): JSX.Element {
    //const classes = useStyles();
    const {
        ImageUrls
    } = props;

    const [open, setOpen] = React.useState(false)
    const [image, setImage] = React.useState('')


    var tempImages: string[] = []
    if (!Array.isArray(ImageUrls)) {
        tempImages.push(ImageUrls)
    }
    else {
        tempImages = ImageUrls
    }

    var data = tempImages.map((item) => {
        return <CardMedia
            key={item}
            style={{ maxHeight: 80, maxWidth: 80, cursor: "pointer" }}
            image={item}
            component='img'
            onClick={() => { setOpen(true); setImage(item) }} />
    })
    return (
        <div>
            {data}
            <CustomImagePreview show={open} images={image} OnButtonClick={() => { setOpen(false) }} />
        </div>
    )
}

